var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavouritesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 36.443,
    viewBox: "0 0 38 36.443",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "romantic_3589399",
    transform: "translate(0.002 -0.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39836",
    "data-name": "Path 39836",
    d: "M18.414,30.521a1.183,1.183,0,0,1-.68-.215C17.052,29.824.979,18.407.979,9.229A9.446,9.446,0,0,1,10.643.039a9.832,9.832,0,0,1,7.771,3.72A9.837,9.837,0,0,1,26.184.039a9.446,9.446,0,0,1,9.664,9.19c0,9.178-16.073,20.595-16.756,21.077A1.174,1.174,0,0,1,18.414,30.521Z",
    transform: "translate(0.584 0)",
    fill: "#d3235f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39837",
    "data-name": "Path 39837",
    d: "M12.747,21.295l-2.632,7.019A1.185,1.185,0,0,1,9,29.095H8.934a1.207,1.207,0,0,1-1.1-.909L6.637,23.4,1.724,25.857A1.2,1.2,0,0,1,.4,25.665a1.191,1.191,0,0,1-.335-1.292L4.229,12.92a60.536,60.536,0,0,0,8.518,8.375Z",
    transform: "translate(0 7.387)",
    fill: "#d3235f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39838",
    "data-name": "Path 39838",
    d: "M28.356,25.665a1.2,1.2,0,0,1-1.324.191L22.119,23.4l-1.2,4.785a1.207,1.207,0,0,1-1.1.909h-.064a1.185,1.185,0,0,1-1.117-.782L16.01,21.295a60.537,60.537,0,0,0,8.518-8.375l4.163,11.453a1.191,1.191,0,0,1-.335,1.292Z",
    transform: "translate(9.239 7.387)",
    fill: "#d3235f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouritesIcon);
export default __webpack_public_path__ + "static/media/favourites_icon.42cfc366767c5035e3c0316d7ef98739.svg";
export { ForwardRef as ReactComponent };